import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

Vue.use(Vuex)

export const store =  new Vuex.Store({
  state: {
    chats:[],
    idToken: null,
    idUser: null,
    userInSession:"",
    roles: [],
    errorLogin: false,
    dialogError: false,
    dialogErrorHeader: "Error en la aplicación",
    dialogErrorMessage: "Se ha presentado un error en el aplicativo. Vuelva a intentarlo más tarde",
    product:{id:"",code:"",name:"",brandId:""},
    users : [],
    usersByRol : [],
    allRols: [],
    companies : [],
    catalogs : [],
    parameters : [],
    rolesList: [],
    authenticated: false,
    progress: false,
    changePassword: false,
    totalDataFlow:0,
    totalPagesFlow:0,
    usersReport:[],
    menus : [],
    providers: [],
    laboratoryExams: [],
    vaccines:[],
    procedures:[],
    types:[],
    companyAgencies:[],
    companyJobs:[],
    guiasProessat:[],
    guiasProessatData:[],
    patients:[],
    patient:{id:1},
    hojasRuta:[],
    hojaRuta:"",
    gruposHomogenio:[],
    dangerousProcesses:[],
    patientExam:"",
    patientExamNumber:"",
    anamnesis:"",
    anexoSaludTrabajo:"",
    monitoreoOftalmologicoOsdi:"",
    diagnosticosAnamnesis:[],
    diagnosticosAnexosSyT:[],
    diagnosticosAnexos:[],
    anamnesisList:[],
    anamnesisOne:"",
    patientAnamnesis:"",
    workAndHealthOne:"",
    workAndHealthList:[],
    patientMonitoringOne:"",
    patientMonitoringList:[],
    patientFileList:[],
    fileData:[],
    covidList:[],
    covidTraceList:[],
    covid:"",
    seguimiento:[],
    covidPatient:"",
    covidFichaSearch:"",
    covidAlarmSearch:"",
    oftalmoList:[],
    drawer:true,
    toolbar:true,
    buscadorPaciente:'',
    scoreFraminghan:'',
    userRouteSheetStatus:'',
    activities : [],
    activitiesTemporal : [],
    companyActivityUser : {},
    activity: '',
    activityFileList: [],
    activitySearch: '',
    searchObjectActivity:null,



  },
  getters,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/store.js